import { Truck } from "lucide-react";
import { formatDateTime } from "@/lib/date-formatters";

interface Shipment {
  id: number;
  tracking_number: string | null;
  status: string;
  error_message: string | null;
  credential_name: string;
  created_at: string;
}

interface ShipmentsHistoryProps {
  shipments: Shipment[];
}

export default function ShipmentsHistory({ shipments }: ShipmentsHistoryProps) {
  if (shipments.length === 0) return null;

  return (
    <div className="bg-white rounded-xl border border-border/60 overflow-hidden">
      <div className="px-5 py-3 border-b border-border/40 flex items-center gap-2">
        <Truck className="size-4 text-muted-foreground" />
        <h3 className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">
          Historija slanja
        </h3>
      </div>
      <div className="divide-y divide-border/40">
        {shipments.map((s) => (
          <div key={s.id} className="px-5 py-3 text-sm">
            <div className="flex items-center justify-between">
              <span className="text-xs text-muted-foreground">{s.credential_name}</span>
              <span
                className={`text-[10px] font-medium px-1.5 py-0.5 rounded-full ${
                  s.status === "created"
                    ? "bg-emerald-50 text-emerald-700"
                    : "bg-red-50 text-red-700"
                }`}
              >
                {s.status === "created" ? "Uspješno" : "Neuspješno"}
              </span>
            </div>
            {s.tracking_number && (
              <p className="font-mono text-xs mt-1">{s.tracking_number}</p>
            )}
            {s.error_message && (
              <p className="text-xs text-red-600 mt-1">{s.error_message}</p>
            )}
            <p className="text-[10px] text-muted-foreground mt-1">
              {formatDateTime(s.created_at)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
